<div class="flex items-center justify-center min-h-screen bg-slate-100">
  <div class="text-center">
    @if (error()) {
      <div class="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
        <div class="text-red-600 mb-4">
          <svg class="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <p class="text-red-800 font-semibold mb-2">Error de Autenticación</p>
        <p class="text-red-600 text-sm mb-4">{{ error() }}</p>
        <button 
          (click)="goHome()" 
          class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
          Volver al inicio
        </button>
        <p class="text-xs text-slate-500 mt-4">Revisa la consola del navegador (F12) para más detalles</p>
      </div>
    } @else {
      <div>
        <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <p class="text-slate-700 text-lg">Autenticando...</p>
        <p class="text-slate-500 text-sm mt-2">Por favor espera mientras completamos tu inicio de sesión</p>
      </div>
    }
  </div>
</div>
